import { Box, Group, rem, SimpleGrid, Space, Stack, Text } from "@mantine/core"
import { branchCard, footer, mainHeader } from "../Common/Renders"
import { IBranch } from "./Props"

const branches: IBranch[] = [
  {
    image: "/dddepth/dddepth-013.jpg",
    name: "Jamalapur",
    location: "Jaunpur, Uttar Pradesh",
    description: "#74, NH 135A, Main Road, Jamalapur, Jaunpur, 222137."
  },
  {
    image: "/dddepth/dddepth-046.jpg",
    name: "Rampur",
    location: "Jaunpur, Uttar Pradesh",
    description: "NH 135A, Main Market, Rampur, Jaunpur, 222203."
  },
  {
    image: "/dddepth/dddepth-086.jpg",
    name: "Shahganj",
    location: "Jaunpur, Uttar Pradesh",
    description: "Milat Nagar, Jaunpur Road, Shahganj, 223101."
  },
  {
    image: "/dddepth/dddepth-091.jpg",
    name: "Bardah",
    location: "Azamgarh, Uttar Pradesh",
    description: "Main Market, Bardah, Jaunpur Road, Azamgarh, 276301."
  },
  {
    image: "/dddepth/dddepth-106.jpg",
    name: "Devgaon",
    location: "Azamgarh, Uttar Pradesh",
    description: "Varanasi Road, Devgao(Usarauli), Lalganj, Azamgarh, 276201."
  },
  {
    image: "/dddepth/dddepth-039.jpg",
    name: "Madhuban",
    location: "Mau, Uttar Pradesh",
    description: "Near Union Bank, Upharauli, Madhuban, Mau, Uttar Pradesh, 221603."
  }
]

export function Branches(): React.ReactElement {
  return (
    <Box p={"md"}>
      {mainHeader()}

      <Space h={rem(32)} />

      <Stack gap={rem(16)}>
        <Text size={rem(18)} opacity={0.85}>
          {
            "We are continuously expanding our presence to serve you better. Here are some of our branches across India. For more information, please contact us."
          }
        </Text>
      </Stack>

      <Space h={rem(32)} />

      <Group mb={rem(32)}>
        <Text size={rem(32)} fw={700}>
          Our Branches
        </Text>
      </Group>

      <SimpleGrid className="branches" cols={{ base: 1, sm: 2, md: 3 }} spacing={rem(16)}>
        {branches.map((branch, index) => branchCard(index, branch))}
      </SimpleGrid>

      <Space h={rem(48)} />

      {footer()}
    </Box>
  )
}
